<template>
<transition name="g-message-fade" @after-leave="handleAfterLeave">
    <div
        :class="[
            bem('', [
                type && !icon ? type : '',
                center ? 'center' : '',
                showClose ? 'closable' : '',
            ]),
            customClass,
        ]"
        :style="positionStyle"
        v-show="visible"
        @mouseenter="clearTimer"
        @mouseleave="startTimer"
        role="alert"
    >
        <Icon :class="bem('icon')" v-if="icon" :name="icon" />
        <Icon :class="bem('icon', type)" v-else :name="iconType" />
        <slot>
            <p v-if="!dangerouslyUseHTMLString" :class="bem('content')">{{ message }}</p>
            <p v-else v-html="message" :class="bem('content')"/>
        </slot>
        <Icon v-if="showClose" :class="bem('closeBtn')" name="gdd-close" @click.native="close" />
    </div>
</transition>

</template>
<script>
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Icon from '../icon';
import { bemMixin } from '../utils';
var typeMap = {
  success: 'gdd-check-circle-solid',
  info: 'gdd-warning-fill',
  warning: 'gdd-warning-fill',
  error: 'gdd-close-circle-fill'
};
export default {
  name: 'g-message',
  components: {
    Icon
  },
  mixins: [bemMixin],

  data() {
    return {
      visible: false,
      message: '',
      duration: 3000,
      type: 'info',
      icon: '',
      customClass: '',
      onClose: null,
      showClose: false,
      closed: false,
      verticalOffset: 20,
      timer: null,
      dangerouslyUseHTMLString: false,
      center: false
    };
  },

  computed: {
    iconType() {
      return this.type && !this.icon ? typeMap[this.type] : '';
    },

    positionStyle() {
      return {
        top: this.verticalOffset + "px"
      };
    }

  },
  watch: {
    closed(newVal) {
      if (newVal) {
        this.visible = false;
      }
    }

  },

  mounted() {
    this.startTimer();
    document.addEventListener('keydown', this.keydown);
  },

  beforeDestroy() {
    document.removeEventListener('keydown', this.keydown);
  },

  methods: {
    handleAfterLeave() {
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    },

    close() {
      this.closed = true;

      if (typeof this.onClose === 'function') {
        this.onClose(this);
      }
    },

    clearTimer() {
      clearTimeout(this.timer);
    },

    startTimer() {
      var _this = this;

      if (this.duration > 0) {
        this.timer = setTimeout(function () {
          if (!_this.closed) {
            _this.close();
          }
        }, this.duration);
      }
    },

    keydown(e) {
      if (e.keyCode === 27) {
        // esc关闭消息
        if (!this.closed) {
          this.close();
        }
      }
    }

  }
};
</script>
<style>
.g-message {
  min-width: 380px;
  box-sizing: border-box;
  border-radius: 4px;
  position: fixed;
  left: 50%;
  top: 20px;
  transform: translateX(-50%);
  background-color: #fff;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.16);
  transition: opacity 0.3s, transform 0.4s, top 0.4s;
  overflow: hidden;
  padding: 12px;
  display: flex;
  align-items: center;
}
.g-message--center {
  justify-content: center;
}
.g-message--closable .g-message__content {
  padding-right: 28px;
}
.g-message p {
  margin: 0;
}
.g-message--success {
  background-color: #eff9f3;
}
.g-message--warning {
  background-color: #fff7eb;
}
.g-message--error {
  background-color: #fcf0f2;
}
.g-message__icon {
  font-size: 20px;
  margin-right: 8px;
}
.g-message__content {
  padding: 0;
  font-size: 14px;
  line-height: 24px;
  color: #000;
}
.g-message__content:focus {
  outline-width: 0;
}
.g-message__closeBtn {
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  cursor: pointer;
  color: #939BA6;
  font-size: 16px;
}
.g-message__closeBtn:focus {
  outline-width: 0;
}
.g-message__closeBtn:hover {
  color: #939BA6;
}
.g-message .g-message__icon--success {
  color: #3BB46D;
}
.g-message .g-message__icon--error {
  color: #de415c;
}
.g-message .g-message__icon--info {
  color: #2254f4;
}
.g-message .g-message__icon--warning {
  color: #ffa000;
}
.g-message-fade-enter,
.g-message-fade-leave-active {
  opacity: 0;
  transform: translate(-50%, -100%);
}

</style>
